var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadCastCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.819,
    height: 20.837,
    viewBox: "0 0 20.819 20.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "megaphone-outline",
    transform: "translate(-47.5 -47.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M65.148,48.2s-4.128,5.135-8,5.135H49.525a.762.762,0,0,0-.762.762v4.574a.762.762,0,0,0,.762.762h7.623c3.873,0,8,5.156,8,5.156a.7.7,0,0,0,1.146-.468V48.666A.677.677,0,0,0,65.148,48.2ZM48.762,57.908S48,57.622,48,56.384s.762-1.525.762-1.525m18.295,2.573a1.1,1.1,0,0,0,0-2.1m-9.147-2v6.1m-6.861-6.1v6.1",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M144,288v8a.381.381,0,0,0,.381.381h2.525a.762.762,0,0,0,.728-.988c-.4-1.281-1.348-2.725-1.348-5.111h.762a.762.762,0,0,0,.762-.762v-.762a.762.762,0,0,0-.762-.762h-.762",
    transform: "translate(-91.426 -228.567)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadCastCardIcon);
export default __webpack_public_path__ + "static/media/Broad-cast-card-icon.c191040a304910e64d361f49a0272467.svg";
export { ForwardRef as ReactComponent };